/**
 * PaymentStatus: Payment lifecycle for a CustomerBillPush row.
 *
 * - NONE: No payment tracked (Enterprise pushes — payment happens off-platform via Zoho)
 * - PENDING: Razorpay payment link issued, awaiting customer payment
 * - PAID: Razorpay webhook confirmed payment captured; Zoho invoice created
 * - FAILED: Razorpay link expired or payment attempt failed; awaiting retry
 */
export enum PaymentStatus {
  NONE = 'NONE',
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAILED = 'FAILED',
}
